import Vue from 'vue';
import { HTTP_DESKDAF, HTTP_EDOCSIGN } from '../plugins/axios';

class AuthApi {
  /**
   * Method used to login.
   *
   * @param {String} username The username.
   * @param {String} password The password.
   *
   * @returns {Promise} The result in a promise.
   */
  static login({ username, password }) {
    const data = {
      login: username,
      password,
    };
    return Vue.$http.post('/login', data);
  }

  /**
   * Method used to login in edocSign.
   *
   * @param {String} username The username.
   * @param {String} password The password.
   *
   * @returns {Promise} The result in a promise.
   */
  static loginEdocSign({ login, password }) {
    return HTTP_EDOCSIGN.post(
      '/authentication/authenticateAccount',
      {
        login,
        password,
      },
    ).then(response => response);
  }

  static loginDeskDaf({ login, password }) {
    return HTTP_DESKDAF.post(
      '/login',
      {
        login,
        password,
      },
    ).then(response => response);
  }
}

export default AuthApi;



// WEBPACK FOOTER //
// ./src/api/AuthApi.js